import { Themes } from '@loadsmart/loadsmart-ui/dist/theming'
import React, { useRef } from 'react'
import ReactDOM from 'react-dom/client'
import TagManager from 'react-gtm-module'
import { QueryClientProvider, QueryClient } from 'react-query'
import { Provider } from 'react-redux'
import { createGlobalStyle } from 'styled-components'

import { Router } from './components/Router'
import { GTM_ID, IS_PROD } from './config/env'
import { ExportProvider } from './hooks/useObservationExports'
import { useStore } from './store/index'
import { reset } from './styles/reset'
import { theme } from './styles/theme'
import { ThemeProvider } from './styles/ThemeProvider'
import analytics from './util/analytics'

const GlobalStyles = (): JSX.Element => {
  const GStyles = createGlobalStyle`
  ${reset}
  .intercom-launcher {
    display: none!important;
  }
  html, body, #root {
    display: flex;
    flex-flow: column nowrap;
    height: 100vh;
    width: 100vw;
    min-width: 350px;
    position: relative;
    overflow: hidden;
  }
  .checkin-sms .ant-list {
    min-width: 390px;
  }
  .checkin-sms .ant-list-item {
    margin-bottom: 2px;
    padding: 5px;
  }
  .user-message {
    border-radius: 10px;
    padding: 5px;
    width: 390px;
    border: 1px #f0f0f0 solid;
  }
  .system-message {
    border-radius: 10px;
    padding: 5px;
    width: 390px;
    background-color: #709FB0;
  }
  .system-message .ant-list-item-meta-title {
    text-align: right;
  }
  .system-message .ant-list-item-meta-description {
    float: right;
  }
`
  return <GStyles />
}

if (IS_PROD) {
  const tagManagerArgs = {
    gtmId: GTM_ID,
  }
  TagManager.initialize(tagManagerArgs)
}

analytics.init()

function App(): JSX.Element {
  const queryClientRef = useRef<QueryClient | undefined>()

  if (!queryClientRef.current) {
    queryClientRef.current = new QueryClient()
  }

  const store = useStore(undefined)

  return (
    <QueryClientProvider client={queryClientRef.current}>
      <Provider store={store}>
        <ThemeProvider theme={{ ...Themes.Miranda, ...theme }}>
          <ExportProvider>
            <>
              <GlobalStyles />
              <Router />
            </>
          </ExportProvider>
        </ThemeProvider>
      </Provider>
    </QueryClientProvider>
  )
}

ReactDOM.createRoot(document.getElementById('root')).render(<App />)
